import domReady from "@wordpress/dom-ready";
import './web-components/routes'
import {EVENT_ROUTE_UNVOTE, EVENT_ROUTE_VOTE, EventRouteUnvote, EventRouteVote} from "./web-components/events";
import ClimbPressRoute from "./web-components/route";
import {getVoteCache, setVoteCache} from "./lib/cache";
import {changeVote, unvote, vote} from "./public-api";

import './web-components/theme.css';
import ClimbPressRoutes from "./web-components/routes";
import {Vote} from "./_types";

domReady(() => {

    document.querySelectorAll("climbpress-route").forEach((element) => {
        if (element.route == null) return;
        element.vote = getVoteCache(element.route.id)?.vote ?? null;
    })
    document.querySelectorAll("climbpress-routes").forEach((element) => {
        const votes: {[route:number]: Vote} = {}
        element.routes.forEach(route => {
            const vote = getVoteCache(route.id)?.vote;
            if(vote){
                votes[route.id] = vote;
            }
        });
        element.votes = votes;
    })

    // @ts-ignore
    window.addEventListener(EVENT_ROUTE_UNVOTE, async (event: CustomEvent<EventRouteUnvote>) => {
        const element = (event.target as Element);
        if (element.localName == "climbpress-routes") {
            const element = (event.target as ClimbPressRoutes);
            const voteId = getVoteCache(event.detail.route)?.voteId;

            if (!voteId) return;

            const success = await unvote(voteId);
            if (!success) {
                return;
            }

            setVoteCache(event.detail.route, null);
            const votes: {[route:number]: Vote} = {};
            Object.entries(element.votes).forEach(([route, vote]) => {
                const routeId = parseInt(route);
                if(routeId != event.detail.route && vote != undefined){
                    votes[routeId] = vote;
                }
            });
            element.votes = votes;

        } else if(element.localName == "climbpress-route"){
            const element = (event.target as ClimbPressRoute);
            const currentVote = element.vote;
            if (currentVote == null) return;

            const routeId = element.route?.id!

            const voteId = getVoteCache(routeId)?.voteId;
            if (!voteId) return;


            const success = await unvote(voteId);
            if (!success) {
                return;
            }
            setVoteCache(routeId, null);
            element.vote = null;
        }

    })

    // @ts-ignore
    window.addEventListener(EVENT_ROUTE_VOTE, async (event: CustomEvent<EventRouteVote>) => {
        const element = (event.target as Element);
        if (element.localName == "climbpress-routes") {
            const routesElement = element as ClimbPressRoutes;
            const {route, difficulty} = event.detail;
            const vote = await doVote(difficulty, route);
            if(vote === false) return;

            routesElement.votes = {
                ...routesElement.votes,
                [route]: {difficulty},
            };
        } else if (element.localName == "climbpress-route") {
            const routeElement = element as ClimbPressRoute;
            const route = routeElement.route;
            if (route == null) return;

            const difficulty = event.detail.difficulty;

            const vote = await doVote(difficulty, route.id);
            if(vote === false) return;
            routeElement.vote = vote;
        }
    });

    async function doVote(difficulty: number, routeId: number): Promise<Vote|false> {

        const currentVoteCache = getVoteCache(routeId);

        if (currentVoteCache == null) {
            const voteId = await vote(routeId, difficulty);
            if (!voteId) {
                return false;
            }
            setVoteCache(routeId, {
                voteId: voteId,
                vote: {
                    difficulty,
                },
            });
        } else {
            const success = await changeVote(currentVoteCache.voteId, difficulty);
            if (!success) {
                return false;
            }
            setVoteCache(routeId, {
                voteId: currentVoteCache.voteId,
                vote: {
                    difficulty,
                }
            });
        }
        return {
            difficulty,
        }
    }
})